import { hookToAttributeSelector } from '@wix/panda-js-utils';
import { SEAT_SPACING, SEAT_CIRCLE_DIAMETER, ROW_LABEL_WIDTH } from '../../constants';
import { SHAPE } from '../../interfaces';
import { getElement } from '../../utils/utils';
import { DH } from '../../data-hooks';
import { getFactualElementPosition } from '../../utils/bounding-boxes';
import { createLabelGenerator } from '../../utils/label-generator';
import { getPlaceElementId } from '../../utils/place';
const HORIZONTAL_LABEL_PADDING = 6;
export const getLeftRowLabelPosition = (_definition) => ({
    x: -(ROW_LABEL_WIDTH + HORIZONTAL_LABEL_PADDING),
    y: 0,
});
export const getRightRowLabelPosition = (definition) => ({
    x: definition.width + HORIZONTAL_LABEL_PADDING,
    y: 0,
});
export const getSeatsAmount = (size, spacing = SEAT_SPACING) => {
    const reservedSeatSpace = spacing + SEAT_CIRCLE_DIAMETER;
    const amount = size < SEAT_CIRCLE_DIAMETER ? 0 : Math.floor(size / reservedSeatSpace) + 1;
    return amount;
};
export const getSeatsLength = (seats, spacing = SEAT_SPACING) => SEAT_CIRCLE_DIAMETER * seats + spacing * (seats - 1);
export const getRowContainerInfo = (definition) => ({
    height: SEAT_CIRCLE_DIAMETER,
    width: definition.width,
});
export const getRows = ({ definition, absolutePosition = false, shapeContainer, actionContainer, svgViewBox, }) => {
    const { width, startAt, labelPosition, reverseDirection, sectorLabel, sequence, spacing = SEAT_SPACING, spacingBetweenRows: rowSpacing = SEAT_SPACING, shapeBorderColor, shapeColor, shapeTextColor, rowsSequence, rowsStartAt, rowsReverseDirection, groupId, categoryId, } = definition;
    const verticalReservedSeatSpace = rowSpacing + SEAT_CIRCLE_DIAMETER;
    const rowsAmount = getSeatsAmount(definition.height, definition.spacingBetweenRows);
    const rows = [];
    let rowPositions = [];
    if (absolutePosition) {
        if (shapeContainer) {
            rowPositions = getActualRowPositions(definition, shapeContainer, svgViewBox) ?? [];
        }
        if (!rowPositions.length && actionContainer) {
            rowPositions = getActualRowPositions(definition, actionContainer, svgViewBox) ?? [];
        }
    }
    const rowLabelGenerator = createLabelGenerator({
        sequence: rowsSequence,
        startAt: rowsStartAt,
        reverseDirection: rowsReverseDirection,
        capacity: rowsAmount,
    });
    const rowPlaceMap = {};
    for (const place of definition.places ?? []) {
        const shapeId = getPlaceElementId(place);
        rowPlaceMap[shapeId] = rowPlaceMap[shapeId] ?? [];
        rowPlaceMap[shapeId].push(place);
    }
    definition.rows.forEach((row, rowIndex) => {
        const capacity = getSeatsAmount(row.overrides.width ?? width, row.overrides.spacing ?? spacing);
        const defaultRowLabel = rowLabelGenerator.getLabelByIndex(rowIndex);
        const x = row.overrides?.relativeX ?? 0;
        const y = rowIndex * verticalReservedSeatSpace;
        const rowDefinition = {
            id: row.id,
            type: SHAPE.ROW,
            angle: 0,
            x,
            y,
            width: row.overrides.width,
            height: SEAT_CIRCLE_DIAMETER,
            startAt: row.overrides?.startAt ?? startAt,
            label: row.overrides?.label ?? defaultRowLabel,
            labelPosition: row.overrides?.labelPosition ?? labelPosition,
            reverseDirection: row.overrides?.reverseDirection ?? reverseDirection,
            capacity,
            sectorLabel,
            sequence: row.overrides?.sequence ?? sequence,
            spacing: row.overrides?.spacing ?? spacing,
            shapeBorderColor: row.shapeBorderColor ?? shapeBorderColor,
            shapeColor: row.shapeColor ?? shapeColor,
            shapeTextColor: row.shapeTextColor ?? shapeTextColor,
            groupId,
            places: rowPlaceMap[row.id] ?? [],
            categoryId,
            placeOverrides: row.placeOverrides ?? [],
        };
        if (absolutePosition) {
            rowDefinition.x = rowPositions[rows.length].x - definition.x;
            rowDefinition.y = rowPositions[rows.length].y - definition.y;
            rowDefinition.angle = definition.angle;
        }
        rows.push(rowDefinition);
    });
    return rows;
};
const getActualRowPositions = (definition, shapeContainer, svgViewBox) => {
    if (!shapeContainer && !shapeContainer.parentElement) {
        throw new Error('Cannot calculate absolute position of rows without having a reference to main SVG container');
    }
    const multiRowElement = getElement(definition.id, shapeContainer.parentElement, undefined);
    if (!multiRowElement) {
        return null;
    }
    const rowNodeList = multiRowElement.querySelectorAll(hookToAttributeSelector(DH.MULTI_ROW_ROW));
    const rowRootElements = [];
    rowNodeList.forEach(node => rowRootElements.push(node));
    const rowSeatWrapperElements = rowRootElements.map(root => root.querySelector(hookToAttributeSelector(DH.MULTI_ROW_ROW_SEATS)));
    const positions = rowSeatWrapperElements.map((el, index) => getFactualElementPosition({
        element: el,
        definition: { ...definition, height: SEAT_CIRCLE_DIAMETER, width: definition.rows[index].overrides.width },
        container: shapeContainer,
        svgViewBox,
    }));
    return positions;
};
//# sourceMappingURL=utils.js.map